export const calendar24Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.252 3.75h19.5s1.5 0 1.5 1.5v16.5s0 1.5-1.5 1.5h-19.5s-1.5 0-1.5-1.5V5.25s0-1.5 1.5-1.5m-1.5 6h22.5M6.752 6V.75M17.252 6V.75"/></svg>`,
    name: 'calendar-24'
};